import { ESSENCE_CUSTOMER_ID } from '@/constants/customers';
import { CobrandMatch, PartnerConfig } from '@/types/PartnerConfig';

export enum CobrandedPartnerName {
  Cigna = 'cigna',
  Essence = 'essence',
}

export const COBRANDED_PARTNERS: Record<CobrandedPartnerName, PartnerConfig> = {
  [CobrandedPartnerName.Cigna]: {
    displayName: 'cigna',
    logo: 'cigna',
    match: { channel: '004-CIG' },
    // TODO(CSOL-426): set Cigna's real support email (product input). Until then
    // `<HelpLink/>` falls back to the business default.
    faqKey: 'eop_order_confirmation_cigna_faq',
    faqUrl: 'https://support.ouraring.com/hc/articles/44580137578003',
  },
  [CobrandedPartnerName.Essence]: {
    displayName: 'essence',
    logo: 'essence',
    match: { customerId: ESSENCE_CUSTOMER_ID },
  },
};

/**
 * Resolve the co-brand config for an order by evaluating each partner's match
 * rule (by channel or customer id). Returns undefined when nothing matches.
 */
export const matchCobrandedPartner = (
  // An eligibility carries its customer as a nested `customer` object rather
  // than a flat `customerId`, so accept either shape.
  orderOrEligibility?: CobrandMatch & {
    customer?: { id: string } | null;
  },
): PartnerConfig | undefined => {
  if (!orderOrEligibility) return undefined;
  const customerId =
    orderOrEligibility.customerId ?? orderOrEligibility.customer?.id;
  return Object.values(COBRANDED_PARTNERS).find(
    ({ match }) =>
      (match.channel !== undefined &&
        orderOrEligibility.channel === match.channel) ||
      (match.customerId !== undefined && customerId === match.customerId),
  );
};

/**
 * Resolve the one co-brand shared by a set of orders. Every order must resolve
 * to the same co-brand — a mixed set has no single co-brand to render, so it returns undefined.
 */
export const findUniversalCobrandedPartner = (
  orders?: CobrandMatch[],
): PartnerConfig | undefined => {
  if (!orders?.length) return undefined;
  const config = matchCobrandedPartner(orders[0]);
  if (!config) return undefined;
  return orders.every((order) => matchCobrandedPartner(order) === config)
    ? config
    : undefined;
};
